import { cva } from 'cva';
export const checkboxClassNames = [
    '@inline-flex',
    '@items-center',
    '@text-grey-6',
    '@text-b2',
    '[&[data-disabled]]:@text-grey-4',
    '[&[data-disabled]]:@cursor-not-allowed',
];
export const checkboxVariant = cva({
    base: [
        '@relative',
        '@mr-2',
        '@h-4',
        '@w-4',
        '@rounded-sm',
        '@bg-grey-2-a',
        '@text-grey-0',
        '@cursor-pointer',
        '!@pointer-events-auto',
        // border overlay
        'before:@absolute',
        'before:@top-0',
        'before:@left-0',
        'before:@w-full',
        'before:@h-full',
        'before:@border',
        'before:@border-grey-4',
        'before:@rounded-sm',
        // hover active disabled
        'hover:@bg-grey-2',
        'active:@bg-grey-2_5',
        '[&[data-disabled]]:@cursor-not-allowed',
        '[&[data-disabled]]:before:@border-grey-2_3',
        '[&[data-disabled]]:@bg-grey-2',
        '[&[data-disabled]]:@text-grey-0_2',
        // checked
        '[&[data-state=checked]]:@bg-brand1-1',
        '[&[data-state=checked]]:before:@border-grey-2_5',
        // checked: hover active disabled
        '[&[data-state=checked]]:hover:@bg-brand1-9',
        '[&[data-state=checked]]:active:@bg-brand1-0',
        '[&[data-disabled][data-state=checked]]:@bg-brand1-4',
        '[&[data-disabled][data-state=checked]]:hover:@bg-brand1-4',
        '[&[data-disabled][data-state=checked]]:active:@bg-brand1-4',
        '[&[data-disabled][data-state=checked]]:@border-grey-2_3',
        '[&[data-disabled][data-state=checked]]:hover:@border-grey-2_3',
        '[&[data-disabled][data-state=checked]]:active:@border-grey-2_3',
        // indeterminate
        // '[&[data-disabled][data-state=checked]]:@border',
        // '[&[data-disabled][data-state=checked]]:@border-grey-2_5',
        // '[&[data-disabled][data-state=checked]]:@bg-grey-2',
        '[&[data-state=indeterminate]]:after:@bg-brand1-1',
        '[&[data-state=indeterminate]]:after:@absolute',
        '[&[data-state=indeterminate]]:after:@left-1/2',
        '[&[data-state=indeterminate]]:after:@top-1/2',
        '[&[data-state=indeterminate]]:after:@-translate-x-1/2',
        '[&[data-state=indeterminate]]:after:@-translate-y-1/2',
        '[&[data-state=indeterminate]]:after:@w-2',
        '[&[data-state=indeterminate]]:after:@h-2',
    ]
});
export const checkboxIndicatorClassNames = [
    '@hidden',
    '@w-4',
    '@h-4',
    '[[data-state=checked]>&]:@inline',
];
